import React from "react";
import { observer} from "mobx-react";
import GeneralDialog from "./GeneralDialog";
import {responseEnum} from "../../serverClientShared/sharedEnums";
import ConditionalComponent from "../Shared/ConditionalComponent";
import {useStores} from "../../Hooks";

const DeleteUserModal = observer(() => {
    const {modalStore, generalStore} = useStores();

    const {user, isSelf, deleteMethod} = modalStore.modalData;
    if (!user) {
        return null;
    }
    const email = user.Email;

    function closeModal() {
        modalStore.isDeleteUserDialogOpen = false;
        modalStore.modalData = {};
    }

    async function deleteUser() {
        try {
            generalStore.isLoaderOpen = true;
            const deleteSuccess = await deleteMethod(user);
            if (deleteSuccess) {
                closeModal();
            } else {
                modalStore.showErrorMessage(generalStore.translate('problemDeletingUserDetails'));
            }
        } catch (e) {
            console.error(e);
            if (e.response && e.response.status === responseEnum.ILLEGAL_ACTION) {
                modalStore.showErrorMessage(generalStore.translate('deleteUserErrorSentence'));
                closeModal();
            } else {
                modalStore.showErrorMessage(generalStore.translate('problemDeletingUserDetails'));
            }
        }
        generalStore.isLoaderOpen = false;
    }

    return (
        <GeneralDialog
            openControl='isDeleteUserDialogOpen'
            className='delete-dialog'
            onEnter={null}
            title={generalStore.translate('deleteAccount')}
            body={
                <React.Fragment>
                    <div className="dialog-description">{generalStore.translate('deleteUserConfirmSentence1_beforeName')}</div>
                    <br/>
                    <div className="dialog-description"><span><strong>{email}</strong>{generalStore.translate('deleteUserConfirmSentence2_afterName')}</span></div>
                    <br/>
                    <ConditionalComponent if={!!isSelf}>
                        <div className="dialog-description">{generalStore.translate('deleteUserConfirmSentence3')}</div>
                    </ConditionalComponent>
                    <ConditionalComponent if={!isSelf}>
                        <div className="dialog-description">{generalStore.translate('deleteUserConfirmSentence4')}</div>
                    </ConditionalComponent>
                </React.Fragment>
            }
            isConfirmDisabled={false}
            onConfirm={deleteUser}
            confirmText={generalStore.translate('delete')}
        />
    );
});

export default DeleteUserModal;
